export default {
  id: "page7",
  header: "Informacje na temat zwyczajów kulinarnych i używanych produktów",
  show:
    "parseInt(values.ankieta_ciastaSelfCz)<6 || parseInt(values.ankieta_ciastaMixCz)<6",

  questions: [
    {
      type: "justlabel",
      number: "19",
      label:
        "Jak często używa Pan(i) następujących rodzajów <span class='has-text-danger'>dodatków do ciast</span>?",
      info:
        "Dla każdego rodzaju dodatku proszę zaznaczyć jedną odpowiedź pod odpowiednią częstotliwością. "
    },
    {
      type: "choice_names",
      options: [
        "Raz w miesiącu lub częściej",
        "Raz na 2-3 miesiące",
        "2-3 razy w roku",
        "Rzadziej",
        "Wcale"
      ],
      topLine: true,
      bottomLine: true
    },
    {
      label: "Proszek do pieczenia",
      type: "radio",
      id: "kategoria3_proszek",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label: "Cukier waniliowy",
      type: "radio",
      id: "kategoria3_cukier",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label: "Aromaty",
      type: "radio",
      id: "kategoria3_aromaty",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label: "Kremy budyniowe typu karpatka (do gotowania i ucierane z masłem)",
      type: "radio",
      id: "kategoria3_kremyBudyn",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label:
        "Kremy, masy z torebki do ciast i tortów (do przygotowania na mleku lub dodawane do bitej śmietany)",
      type: "radio",
      id: "kategoria3_kremyCiasta",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label: "Dodatek do bitej śmietany (Śmietan-Fix/ Fix do śmietany)",
      type: "radio",
      id: "kategoria3_fixSmietana",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label: "Fixy do ciast np. Biszkopt-fix, Sernix",
      type: "radio",
      id: "kategoria3_fixCiasto",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label: "Drożdże instant (suche, w torebce)",
      type: "radio",
      id: "kategoria3_drozdzeInstant",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label: "Drożdże świeże (z lodówki)",
      type: "radio",
      id: "kategoria3_drozdzeSwieze",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label: "Gotowe masy makowe w puszce",
      type: "radio",
      id: "kategoria3_masyMakowe",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label: "Polewy, lukry do ciast (gotowe do użycia po podgrzaniu)",
      type: "radio",
      id: "kategoria3_polewyGotowe",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label: "Polewy, lukry do ciast (wymagające wymieszania z mlekiem, wodą)",
      type: "radio",
      id: "kategoria3_polewyMleko",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label:
        "Żelatyna - używana do ciast i deserów (do usztywniania ciast na zimno, mas śmietanowych, deserów)",
      type: "radio",
      id: "kategoria3_zelatyna",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label: "Budyń - używany do ciast (np. do kremu, serników itp.)",
      type: "radio",
      id: "kategoria3_budynCiasto",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label:
        "Galaretka - używana do ciast (np. do usztywniania ciast na zimno, mas śmietanowych, wylewana na wierzch ciast itp.)",
      type: "radio",
      id: "kategoria3_galaretkaCiasto",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label:
        "Kakao - używane do ciast (do przygotowania ciasta, kremu, polewy)",
      type: "radio",
      id: "kategoria3_kakaoCiasto",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label:
        "Śnieżka / Bita śmietana w torebce do ubijania na mleku używana do ciast",
      type: "radio",
      id: "kategoria3_sniezkaCiasto",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    }
  ]
};



// WEBPACK FOOTER //
// ./src/config/page7.js